<template>
    <div class="wrappers" @click="onCenter">
        <div class="home home-sp" @click.stop v-if="$store.state.screen == 1">
            <div class="home-content">
                <transition name="component-fade" mode="out-in">
                    <router-view :key='key' />
                </transition>
            </div>
            <div class="home-menu">
                <div
                    class="menu"
                    :class="{'active-menu': activeIndex == index}"
                    v-for="(item, index) in menuList"
                    :key="index"
                    @click="onMenu(index, item.path)"
                >
                    <img :src="activeIndex == index ? item.actImg : item.notImg" />
                    <div>{{item.name}}</div>
                </div>
            </div>
        </div>
        <div class="home" @click.stop v-else>
            <div class="home-menu" @click.stop>
                <div
                    class="menu"
                    :class="{'active-menu': activeIndex == index}"
                    v-for="(item, index) in menuList"
                    :key="index"
                    @click="onMenu(index, item.path)"
                >
                    <img :src="activeIndex == index ? item.actImg : item.notImg" />
                    <div>{{item.name}}</div>
                </div>
            </div>
            <div class="home-content">
                <transition name="component-fade" mode="out-in">
                    <router-view :key='key' />
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'index',
        data () {
            return {
                menuList: [
                    {
                        actImg: require('images/home_1.png'),
                        notImg: require('images/home_1_1.png'),
                        name: '账号',
                        path: '/'
                    },
                    {
                        actImg: require('images/home_2.png'),
                        notImg: require('images/home_2_1.png'),
                        name: '福利',
                        path: '/base-welfare'
                    },
                    {
                        actImg: require('images/home_3.png'),
                        notImg: require('images/home_3_1.png'),
                        name: '开服',
                        path: '/base-open-service'
                    },
                    {
                        actImg: require('images/home_4.png'),
                        notImg: require('images/home_4_1.png'),
                        name: '消息',
                        path: '/base-message'
                    }
                ],
                activeIndex: 0,
                resizeTimer: null
            }
        },
        computed: {
            key () {
                return this.$route.path
            }
        },
        watch: {
            $route () {
                if (this.$route.meta.active) {
                    this.activeIndex = this.$route.meta.active
                } else {
                    this.activeIndex = 0
                }
            }
        },
        methods: {
            // 关闭sdk
            onCenter () {
                let that = this
                if (that.config.system == 1) {
                    window.Android.closeUserCenter()
                } else if (that.config.system == 2) {
                    window.webkit.messageHandlers.wz_callOC.postMessage({
                        method: 'closeCenter',
                        param: {
                            whether: sessionStorage.getItem('setisball')
                        }
                    })
                }
                sessionStorage.clear()
            },
            onMenu (index, path) {
                this.activeIndex = index
                this.$router.push(path)
            }
        },
        created () {
            if (this.$route.meta.active) {
                this.activeIndex = this.$route.meta.active
            } else {
                this.activeIndex = 0
            }
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22; // 主体颜色
    .wrappers {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    // 横屏css
    .home {
        width: 1230px;
        height: 100%;
        overflow: hidden;
        display: flex;
        .home-menu {
            width: 150px;
            height: 100%;
            background: rgba(0, 0, 0, 0.9);
            .menu {
                height: 25%;
                font-size: 33px;
                transition: all 0.3s;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                img {
                    width: 72px;
                    height: 72px;
                    margin-bottom: 8px;
                }
            }
            .active-menu {
                color: $color;
            }
        }
        .home-content {
            flex: 1;
            overflow-y: scroll;
            overflow-x: hidden;
        }
    }
    // 竖屏css
    .home-sp {
        width: 82%;
        height: 80%;
        border-radius: 60px 0 0 0;
        overflow: hidden;
        position: absolute;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        .home-menu {
            width: 100%;
            height: 300px;
            background: rgba(0, 0, 0, 0.9);
            display: flex;
            .menu {
                width: 25%;
                height: 100%;
                font-size: 60px;
                img {
                    width: 130px;
                    height: 130px;
                    margin-bottom: 14px;
                }
            }
        }
    }
</style>
